












import { NewsRenderModel } from "@/services/news/types";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class VideoRender extends Vue {
    @Prop() private news!: NewsRenderModel;
    @Prop() private active!: boolean;

    reload = false;
    reloadComponent = 0;
    playWithSound = false;

    // lifecycle hooks
    created() {
    }

    staticVideo = {} as HTMLVideoElement;
    videoPlaying = false;

    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: number) {
        if (value === 0 || !this.staticVideo || isNaN(this.staticVideo.readyState)) return;

        if (this.staticVideo.readyState === 0) {
            this.$emit("videoEnded");
            this.$emit("setNextNews");
        }

        if (this.videoPlaying) return;
        this.playVideo();
    }

    // lifecycle hooks
    mounted(): void {
        this.staticVideo = this.$refs.video as HTMLVideoElement;
        this.loadVideo();
    }

    // computed
    get videoUrl(): string {
        return this.news.blobUrl;
    }

    get renderModel() {
        return this.news.content;
    }

    // methods
    loadVideo() {
        this.staticVideo.muted = !this.playWithSound;
        this.staticVideo.autoplay = false;

        // video events
        this.staticVideo.onplaying = () => {
            this.videoPlaying = true;
        };

        this.staticVideo.onended = () => {
            this.staticVideo.currentTime = 0;
            this.videoPlaying = false;
            this.$emit("videoEnded");
            this.$emit("setNextNews");
        };

        // Reset some styles that might ruin the preview and let the css take over
        this.staticVideo.style.top = "";
        this.staticVideo.style.left = "";
        this.staticVideo.style.right = "";
        this.staticVideo.style.bottom = "";
        this.staticVideo.style.position = "";
        this.staticVideo.style.margin = "";

        this.staticVideo.src = this.videoUrl;

        if (this.active && !this.videoPlaying) {
            this.playVideo();
        }
    }

    playVideo() {
        if (this.videoPlaying) return;
        this.videoPlaying = true;
        this.staticVideo.pause();
        this.staticVideo.autoplay = true;
        this.staticVideo.play();
    }

    navigateTo(url: string) {
        window.open(url);
    }
}
